export default __webpack_public_path__ + "static/characters_03_CalCium0-0702a58c785c5e7baeb2f7ec424c410d.png";